<p-toast />
<app-container-manager-login title="Recuperar Senha">
  <form class="p-fluid" autocomplete="off" [formGroup]="form" (submit)="onSubmit()">
    <div class="p-field p-mb-3">
      <label for="usuario" class="p-mb-2 block">E-mail</label>
      <input id="usuario" type="email" pInputText placeholder="Digite seu e-mail" formControlName="usuario" />
      <small class="p-text-muted p-d-block p-mt-2">
        Você receberá um link para redefinir sua senha
      </small>
    </div>
    <div class="p-field p-mb-3">
      <button pButton type="submit" [disabled]="form.invalid || loadding"
        [label]="loadding ? '' : 'Solicitar reset de senha'"
        class="p-button-primary w-full p-d-flex p-jc-center p-ai-center">
        <i class="pi pi-spin pi-spinner" *ngIf="loadding"></i>
      </button>
    </div>

    <div class="p-text-center">
      <a [routerLink]="['/login']" class="p-link auth-link">
        Voltar ao login
      </a>
    </div>
  </form>
</app-container-manager-login>